import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL ? `${process.env.REACT_APP_API_URL}/api/messenger` : '/api/messenger';

export const messengerService = {
  // Conversations
  getConversations: async (token) => {
    try {
      const { data } = await axios.get(`${API_BASE}/conversations`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  getOrCreateConversation: async (conversationData, token) => {
    try {
      // console.log("Sending conversation data:", conversationData);
      const { data } = await axios.post(`${API_BASE}/conversations`, conversationData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      // console.log("Conversation response:", data);
      return data;
    } catch (error) {
      console.error("Conversation creation error:", error.response?.data || error);
      throw error.response?.data || error;
    }
  },

  // Messages
  getMessages: async (conversationId, token, page = 1, limit = 50) => {
    try {
      const { data } = await axios.get(`${API_BASE}/conversations/${conversationId}/messages`, {
        params: { page, limit },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  // Get all messages for media/links/docs (including deleted ones)
  getAllMessagesForMedia: async (conversationId, token) => {
    try {
      const { data } = await axios.get(`${API_BASE}/conversations/${conversationId}/messages/media`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  sendMessage: async (messageData, token) => {
    try {
      const { data } = await axios.post(`${API_BASE}/messages`, messageData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  sendMediaMessage: async (formData, token) => {
    try {
      const { data } = await axios.post(`${API_BASE}/messages/media`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });
      return data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  // Get unread message count for a conversation
  getUnreadCount: async (conversationId, token) => {
    try {
      const { data } = await axios.get(`${API_BASE}/conversations/${conversationId}/unread-count`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return data.count || 0;
    } catch (error) {
      console.error("Error getting unread count:", error);
      return 0;
    }
  },

  // Block a user
  blockUser: async (userId, token) => {
    try {
      const baseUrl = process.env.REACT_APP_API_URL || '';
      const { data } = await axios.post(`${baseUrl}/api/block/blockUser`, { userId }, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return data;
    } catch (error) {
      console.error("Error blocking user:", error);
      throw error.response?.data || error;
    }
  },

  // Unblock a user
  unblockUser: async (userId, token) => {
    try {
      const baseUrl = process.env.REACT_APP_API_URL || '';
      const { data } = await axios.post(`${baseUrl}/api/block/unblockUser`, { userId }, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return data;
    } catch (error) {
      console.error("Error unblocking user:", error);
      throw error.response?.data || error;
    }
  },

  // Get blocked users
  getBlockedUsers: async (token) => {
    try {
      const baseUrl = process.env.REACT_APP_API_URL || '';
      const { data } = await axios.get(`${baseUrl}/api/block/blockedUsers`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return data?.blockedUsers || [];
    } catch (error) {
      console.error("Error fetching blocked users:", error);
      throw error.response?.data || error;
    }
  },

  // Report a user
  reportUser: async (userId, reason, token) => {
    try {
      const { data } = await axios.post(`${API_BASE}/users/${userId}/report`, { reason }, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return data;
    } catch (error) {
      console.error("Error reporting user:", error);
      throw error.response?.data || error;
    }
  },

  // Share contact with another user
  shareContact: async (userId, token) => {
    try {
      const { data } = await axios.post(`${API_BASE}/users/${userId}/share-contact`, {}, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return data;
    } catch (error) {
      console.error("Error sharing contact:", error);
      throw error.response?.data || error;
    }
  },

  // // Export chat conversation
  // exportChat: async (conversationId, token) => {
  //   try {
  //     const { data } = await axios.get(`${API_BASE}/conversations/${conversationId}/export`, {
  //       headers: {
  //         Authorization: `Bearer ${token}`,
  //       },
  //       responseType: 'blob',
  //     });

  //     // Create download link
  //     const url = window.URL.createObjectURL(new Blob([data]));
  //     const link = document.createElement('a');
  //     link.href = url;
  //     link.setAttribute('download', `chat-export-${conversationId}.json`);
  //     document.body.appendChild(link);
  //     link.click();
  //     link.remove();
  //     window.URL.revokeObjectURL(url);

  //     return { success: true };
  //   } catch (error) {
  //     console.error("Error exporting chat:", error);
  //     throw error.response?.data || error;
  //   }
  // },

  // Archive conversation
  // archiveConversation: async (conversationId, token) => {
  //   try {
  //     const { data } = await axios.put(`${API_BASE}/conversations/${conversationId}/archive`, {}, {
  //       headers: {
  //         Authorization: `Bearer ${token}`,
  //       },
  //     });
  //     return data;
  //   } catch (error) {
  //     console.error("Error archiving conversation:", error);
  //     throw error.response?.data || error;
  //   }
  // },

  //  Get archived conversations
  // getArchivedConversations: async (token) => {
  //   try {
  //     const { data } = await axios.get(`${API_BASE}/conversations/archived`, {
  //       headers: {
  //         Authorization: `Bearer ${token}`,
  //       },
  //     });
  //     return data;
  //   } catch (error) {
  //     console.error("Error getting archived conversations:", error);
  //     // Return empty array if endpoint doesn't exist yet
  //     if (error.response?.status === 404) {
  //       console.warn("Archived conversations endpoint not implemented yet, returning empty array");
  //       return [];
  //     }
  //     throw error.response?.data || error;
  //   }
  // },

  // Unarchive conversation
  // unarchiveConversation: async (conversationId, token) => {
  //   try {
  //     const { data } = await axios.put(`${API_BASE}/conversations/${conversationId}/unarchive`, {}, {
  //       headers: {
  //         Authorization: `Bearer ${token}`,
  //       },
  //     });
  //     return data;
  //   } catch (error) {
  //     console.error("Error unarchiving conversation:", error);
  //     throw error.response?.data || error;
  //   }
  // },

  // Mute conversation
  muteConversation: async (conversationId, muteData, token) => {
    try {
      const { data } = await axios.put(`${API_BASE}/conversations/${conversationId}/mute`, muteData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return data;
    } catch (error) {
      console.error("Error muting conversation:", error);
      throw error.response?.data || error;
    }
  },

  // Unmute conversation
  unmuteConversation: async (conversationId, token) => {
    try {
      const { data } = await axios.put(`${API_BASE}/conversations/${conversationId}/unmute`, {}, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return data;
    } catch (error) {
      console.error("Error unmuting conversation:", error);
      throw error.response?.data || error;
    }
  },

  reactToMessage: async (messageId, emoji, token) => {
    try {
      const { data } = await axios.post(`${API_BASE}/messages/${messageId}/react`, { emoji }, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  markAsRead: async (conversationId, token) => {
    try {
      const { data } = await axios.put(`${API_BASE}/conversations/${conversationId}/read`, {}, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  deleteMessage: async (messageId, deleteForEveryone, token) => {
    try {
      const { data } = await axios.delete(`${API_BASE}/messages/${messageId}`, {
        data: { deleteForEveryone },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  editMessage: async (messageId, text, token) => {
    try {
      const { data } = await axios.put(`${API_BASE}/messages/${messageId}`, { text }, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  forwardMessage: async (messageId, conversationIds, token) => {
    try {
      const { data } = await axios.post(`${API_BASE}/messages/${messageId}/forward`, { conversationIds }, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  searchMessages: async (query, conversationId, token) => {
    try {
      const { data } = await axios.get(`${API_BASE}/messages/search`, {
        params: { query, conversationId },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  // Calls
  initiateCall: async (callData, token) => {
    try {
      console.log("📡 Making API call to initiate call:", callData);
      console.log("🔑 Using token:", token ? "Token exists" : "No token");

      // Ensure we have the correct data structure
      const requestData = {
        conversationId: callData.conversationId,
        type: callData.type // 'voice' or 'video'
      };

      console.log("📡 Request data:", requestData);

      const { data } = await axios.post(`${API_BASE}/calls`, requestData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      console.log("📡 API Response:", data);
      return data;
    } catch (error) {
      console.error("📡 API Error:", error);
      console.error("📡 Error response:", error.response?.data);
      console.error("📡 Error status:", error.response?.status);
      console.error("📡 Error headers:", error.response?.headers);
      console.error("📡 Full error object:", error);

      // Extract meaningful error message
      const errorMessage = error.response?.data?.message ||
        error.response?.data?.error ||
        error.message ||
        'Unknown error';

      console.error("📡 Extracted error message:", errorMessage);
      const errorObj = new Error(errorMessage);
      Object.assign(errorObj, error.response?.data);
      throw errorObj;
    }
  },

  answerCall: async (callId, token) => {
    try {
      const { data } = await axios.put(`${API_BASE}/calls/${callId}/answer`, {}, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  declineCall: async (callId, token) => {
    try {
      const { data } = await axios.put(`${API_BASE}/calls/${callId}/decline`, {}, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  endCall: async (callId, token) => {
    try {
      const { data } = await axios.put(`${API_BASE}/calls/${callId}/end`, {}, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  getCallHistory: async (token, page = 1, limit = 20) => {
    try {
      const { data } = await axios.get(`${API_BASE}/calls/history`, {
        params: { page, limit },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  cleanupStuckCalls: async (conversationId, force, token) => {
    try {
      const { data } = await axios.post(`${API_BASE}/calls/cleanup`,
        { conversationId, force },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  getStuckCalls: async (conversationId, token) => {
    try {
      const { data } = await axios.get(`${API_BASE}/calls/stuck${conversationId ? `?conversationId=${conversationId}` : ''}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  // Manual cleanup function for users
  manualCleanup: async (token) => {
    try {
      console.log("🧹 Manual cleanup requested");
      const { data } = await axios.post(`${API_BASE}/calls/cleanup`, {
        force: true
      }, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      console.log("🧹 Manual cleanup completed:", data);
      return data;
    } catch (error) {
      console.error("❌ Manual cleanup failed:", error);
      throw error.response?.data || error;
    }
  },

  // Clear conversation messages for current user
  clearConversation: async (conversationId, token, options = {}) => {
    try {
      const { excludeMessageIds = [] } = options;
      const { data } = await axios.delete(`${API_BASE}/conversations/${conversationId}/clear`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        data: {
          excludeMessageIds,
        },
      });
      return data;
    } catch (error) {
      console.error("Error clearing conversation:", error);
      throw error.response?.data || error;
    }
  },

  // Pin conversation
  pinConversation: async (conversationId, token) => {
    try {
      const { data } = await axios.put(`${API_BASE}/conversations/${conversationId}/pin`, {}, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return data;
    } catch (error) {
      console.error("Error pinning conversation:", error);
      throw error.response?.data || error;
    }
  },

  // Unpin conversation
  unpinConversation: async (conversationId, token) => {
    try {
      const { data } = await axios.put(`${API_BASE}/conversations/${conversationId}/unpin`, {}, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return data;
    } catch (error) {
      console.error("Error unpinning conversation:", error);
      throw error.response?.data || error;
    }
  },

  // Delete conversation
  deleteConversation: async (conversationId, token) => {
    try {
      const { data } = await axios.delete(`${API_BASE}/conversations/${conversationId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return data;
    } catch (error) {
      console.error("Error deleting conversation:", error);
      throw error.response?.data || error;
    }
  },

  // Leave a group conversation. Owners must pass `transferToUserId` to hand
  // admin access to another member before they're allowed to leave.
  leaveGroup: async (conversationId, token, { transferToUserId } = {}) => {
    try {
      const body = transferToUserId ? { transferToUserId } : {};
      const { data } = await axios.post(
        `${API_BASE}/conversations/${conversationId}/leave`,
        body,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return data;
    } catch (error) {
      console.error("Error leaving group:", error);
      throw error.response?.data || error;
    }
  },

  // Owner-only: disband (fully delete) a group conversation. Used when the
  // owner is the only remaining member and there's no one to transfer
  // admin access to.
  disbandGroup: async (conversationId, token) => {
    try {
      const { data } = await axios.post(
        `${API_BASE}/conversations/${conversationId}/disband`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return data;
    } catch (error) {
      console.error("Error disbanding group:", error);
      throw error.response?.data || error;
    }
  },

  // Admin-only: remove a member from a group conversation
  removeGroupMember: async (conversationId, memberId, token) => {
    try {
      const { data } = await axios.post(
        `${API_BASE}/conversations/${conversationId}/remove-member`,
        { memberId },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return data;
    } catch (error) {
      console.error("Error removing group member:", error);
      throw error.response?.data || error;
    }
  },

};

